import React from "react";
import { ComparisonTable } from "./ClassComparison";

function SectionComparison({ data }) {
    return <ComparisonTable data={data} nameLabel="Section" tableName="section_comparison" />;
}

export default SectionComparison;
